export default __webpack_public_path__ + "static/media/94.7e17399c.png";